export default "__VITE_ASSET__0de9e6ba__"